import { FormControl, InputAdornment, TextField } from '@mui/material';
import SearchRounded from '@mui/icons-material/SearchRounded';

import './SearchInput.module.scss';

export const MLSearchInput = ({
  classList = '',
  placeholderText,
  label,
  setSearchChange,
  searchValue = '',
}) => {
  const handleChange = (event) => {
    if (setSearchChange) {
      setSearchChange(event.target.value);
    }
  };

  return (
    <FormControl className={`input-wrap ${classList}`}>
      <TextField
        type="search"
        placeholder={placeholderText}
        inputProps={{ 'aria-label': label ?? placeholderText }}
        variant="outlined"
        onChange={handleChange}
        value={searchValue ?? ''}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRounded />
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};
